import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetClubPhoneNumberFragment_club$key } from "./__generated__/useGetClubPhoneNumberFragment_club.graphql";

export const useGetClubPhoneNumber = (
  clubRef: useGetClubPhoneNumberFragment_club$key | null
) => {
  const club = useFragment(useGetClubPhoneNumberFragmentString, clubRef);
  return club?.phoneNumber?.formattedNumber;
};

const useGetClubPhoneNumberFragmentString = graphql`
  fragment useGetClubPhoneNumberFragment_club on Club {
    phoneNumber {
      formattedNumber
    }
  }
`;
